module.exports = __webpack_public_path__ + "img/rmoney logo.a6d127a8.png";